module.exports = __webpack_public_path__ + "img/france-genitourinary-diseases-male.3dd25986.png";